/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// NOTE: Used by the drag n drop directive to store the draggable data
@Injectable()
export class DragDropService {
    // Notify all directives a drop has happened
    public dropOccurred: Subject<boolean> = new Subject<boolean>();

    // Item to remove
    public resetNodePosition: Subject<any> = new Subject<any>();

    // Rerun contentInitialSetup
    public reRunInitialSetup: Subject<any> = new Subject<any>();

    // Set flag drag active
    public dragActive: Subject<boolean> = new Subject<boolean>();
}
